<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.common.Domain' | translate }}</th>
				<th>{{ 'adminstat.billing.domain_billing.Contact details' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details">
				<td>
					{{ stat.domain }}
				</td>
				
				<td>
					<ngb-accordion #acc="ngbAccordion">
						<ngb-panel title="{{ 'adminstat.common.show all' | translate }}">
							<ng-template ngbPanelContent>
								<ul>
									<li *ngFor="let key of stat.saveContact | keys">
										{{ key }}: {{ stat.saveContact[key] }}
									</li>
								</ul>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
